import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { CorporateDesignPageComponent } from '../pages/cms/corporate-design/corporate-design-page.component';
import { FormChangedGuard } from './form-changed-guard/form-changed-guard';

@Injectable({
  providedIn: 'root',
})
export class CorporateDesignPageGuard
  extends FormChangedGuard
  implements CanDeactivate<CorporateDesignPageComponent>
{
  canDeactivate(
    component: CorporateDesignPageComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.handleNavigation(
      component.hasUnsavedChanges(),
      nextState.url,
      (): void => component.cancel(),
      (): Promise<boolean> => component.save()
    );
  }
}
